import React, { useState, useEffect } from 'react';
import { X, Check, UserPlus } from 'lucide-react';
import api from '../api';

const FriendPickerModal = ({ isOpen, onClose, userId, friends, onConfirm, title = '选择好友' }) => {
  const [selectedFriends, setSelectedFriends] = useState([]);

  useEffect(() => {
    if (isOpen) {
      setSelectedFriends([]);
    }
  }, [isOpen]);

  const toggleFriend = (friend) => {
    setSelectedFriends(prev => {
      const exists = prev.find(f => f.friendId === friend.friendId);
      if (exists) {
        return prev.filter(f => f.friendId !== friend.friendId);
      }
      return [...prev, friend];
    });
  };

  const handleConfirm = () => {
    if (selectedFriends.length >= 1) {
      onConfirm(selectedFriends);
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[60] bg-black/80 flex items-center justify-center p-4">
      <div className="bg-[#1a1a2e] rounded-3xl w-full max-w-md max-h-[80vh] overflow-hidden">
        <div className="flex items-center justify-between p-4 border-b border-white/10">
          <button onClick={onClose} className="p-2 rounded-full hover:bg-white/10">
            <X size={20} className="text-white" />
          </button>
          <h2 className="text-lg font-bold text-white">{title}</h2>
          <button
            onClick={handleConfirm}
            disabled={selectedFriends.length < 1}
            className={`p-2 rounded-full ${selectedFriends.length >= 1 ? 'bg-[var(--neon-primary)] text-black' : 'bg-gray-600 text-gray-400'}`}
          >
            <Check size={20} />
          </button>
        </div>

        <div className="p-4">
          {selectedFriends.length > 0 && (
            <div className="mb-4">
              <p className="text-gray-400 text-sm mb-2">已选择 {selectedFriends.length} 人</p>
              <div className="flex flex-wrap gap-2">
                {selectedFriends.map(friend => (
                  <span
                    key={friend.friendId}
                    className="px-3 py-1 bg-[var(--neon-primary)]/20 text-[var(--neon-primary)] rounded-full text-sm flex items-center gap-1"
                  >
                    {friend.friendName || friend.friendId}
                    <button onClick={() => toggleFriend(friend)}>
                      <X size={14} />
                    </button>
                  </span>
                ))}
              </div>
            </div>
          )}

          <div className="overflow-y-auto max-h-[50vh] space-y-2">
            {friends && friends.length > 0 ? (
              friends.map(friend => {
                const isSelected = selectedFriends.find(f => f.friendId === friend.friendId);
                return (
                  <div
                    key={friend.friendId}
                    onClick={() => toggleFriend(friend)}
                    className={`p-3 rounded-xl flex items-center gap-3 cursor-pointer transition-colors ${
                      isSelected ? 'bg-[var(--neon-primary)]/20 border border-[var(--neon-primary)]' : 'bg-white/5 hover:bg-white/10'
                    }`}
                  >
                    <img
                      src={friend.friendAvatar || `https://api.dicebear.com/7.x/avataaars/svg?seed=${friend.friendId}`}
                      alt={friend.friendName}
                      className="w-10 h-10 rounded-full"
                    />
                    <div className="flex-1">
                      <p className="text-white font-medium">
                        {friend.friendName || friend.friendEmail?.split('@')[0] || friend.friendId}
                      </p>
                      <p className="text-gray-500 text-xs">{friend.friendEmail}</p>
                    </div>
                    {isSelected && (
                      <div className="w-6 h-6 rounded-full bg-[var(--neon-primary)] flex items-center justify-center">
                        <Check size={14} className="text-black" />
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <div className="text-center py-8">
                <UserPlus size={40} className="text-gray-500 mx-auto mb-2" />
                <p className="text-gray-400">暂无好友</p>
                <p className="text-gray-500 text-sm">先去添加好友吧~</p>
              </div>
            )}
          </div>
        </div>

        <div className="p-4 border-t border-white/10">
          <button
            onClick={handleConfirm}
            disabled={selectedFriends.length < 1}
            className={`w-full py-3 rounded-xl font-bold transition-colors ${
              selectedFriends.length >= 1
                ? 'bg-[var(--neon-primary)] text-black'
                : 'bg-gray-600 text-gray-400 cursor-not-allowed'
            }`}
          >
            确定创建群聊 ({selectedFriends.length}人)
          </button>
        </div>
      </div>
    </div>
  );
};

export default FriendPickerModal;
